import DiscountIcon from '@/assets/icons/ic_discount.svg';
import ExploreIcon from '@/assets/icons/ic_explore.svg';
import IconHomeIntro from '@/assets/images/home/home-intro.png';
import IconDiscount from '@/assets/images/home/discount.png';
import GradientButton from '@/components/UI/GradientButton';
import { analyticsLogEvent, userPropertiesLogEvent } from '@/firebase';
import { eventTracking } from '@/firebase/firebase';
import useScreenSize from '@/hooks/useScreenSize';
import { ReactNode, useCallback, useState } from 'react';
import { HomeDescription, HomeTitle, KeyText } from '../../style';
import {
  BodyButton,
  ButtonWrapper,
  CarouselWrapper,
  CustomContentWrapper,
  DiscountShadow,
  FrameContent,
  FrameImageRight,
  FrameRight,
  Header,
  ToolImg,
  ToolShadow,
  Wrapper,
} from './style';
import DiscountEventModal from '@/components/Pricing/PricingModal/DiscountEventModal';

interface Slide {
  id: string;
  title: string;
  description: ReactNode;
  actionButton: ReactNode;
  frameRight: ReactNode;
}

const HeaderPage = () => {
  const { isMobile } = useScreenSize();
  const [isOpenDiscount, setIsOpenDiscount] = useState(false);

  const handleCloseDiscountEvent = useCallback(() => {
    setIsOpenDiscount(false);
  }, [isOpenDiscount]);

  const goToProduct = useCallback(() => {
    analyticsLogEvent(eventTracking.landingPageExploreClick.name);
    userPropertiesLogEvent();

    const product: any = document.getElementById('product');
    if (product) {
      product.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const slides = [
    {
      id: 'toolkit',
      title: 'Essential AI Toolkit for Content Creators',
      description:
        'We empower content creators like you to unleash their full creative potential. Our essential AI Toolkit is designed to revolutionize your content creation process and help you stand out from the crowd.',
      actionButton: (
        <GradientButton
          onClick={goToProduct}
          body={
            <BodyButton>
              <img src={ExploreIcon} alt="explore-icon" />
              <p>{'Explore All Tools'}</p>
            </BodyButton>
          }
          isFullWidth={isMobile}
        />
      ),
      frameRight: (
        <FrameRight>
          <ToolImg src={IconHomeIntro} alt={'tool-img'} />
          <ToolShadow
            style={{ top: '5px', left: '-20px', filter: 'blur(90.5px)' }}
          />
          <ToolShadow style={{ right: '0px', bottom: '50px' }} />
        </FrameRight>
      ),
    },
    {
      id: 'discount',
      title: 'X2 Credits for the First 100 subscribers',
      description: (
        <>
          Use code <b style={{ color: '#fff' }}>EARLY100</b> at checkout for x2
          credits. Limited to the first 100 subscribers only. Unlock
          turbocharged content creation with our essential AI toolkit.
        </>
      ),
      actionButton: (
        <GradientButton
          onClick={() => {
            setIsOpenDiscount(true);
          }}
          body={
            <BodyButton>
              <img src={DiscountIcon} alt="discount-icon" />
              <p>{'Claim Your Discount'}</p>
            </BodyButton>
          }
          isFullWidth={isMobile}
        />
      ),
      frameRight: (
        <FrameRight>
          <ToolImg
            className="img-discount"
            src={IconDiscount}
            alt={'discount-image'}
          />
          <DiscountShadow style={{ top: '5px', right: '30px' }} />
          <DiscountShadow style={{ left: '0px', top: '45%' }} />
        </FrameRight>
      ),
    },
  ] as Slide[];

  return (
    <Wrapper>
      <CarouselWrapper
        dots={{ className: 'dots-wrapper' }}
        autoplay
        autoplaySpeed={5000}
      >
        {slides.map((slide) => (
          <Body key={slide?.id} {...slide} />
        ))}
      </CarouselWrapper>

      <DiscountEventModal
        isOpen={isOpenDiscount}
        onClose={handleCloseDiscountEvent}
      />
    </Wrapper>
  );
};

export default HeaderPage;

const Body = ({ title, description, actionButton, frameRight }: Slide) => {
  return (
    <Header>
      <FrameContent>
        <CustomContentWrapper>
          <KeyText>EXCLUSIVE OFFER</KeyText>
          <HomeTitle>{title}</HomeTitle>
          <HomeDescription>{description}</HomeDescription>
        </CustomContentWrapper>
        <ButtonWrapper>{actionButton}</ButtonWrapper>
      </FrameContent>
      <FrameImageRight>{frameRight}</FrameImageRight>
    </Header>
  );
};
